import { useQuery } from '@tanstack/react-query';
import { getSSOStatus } from '../../api/sso';

export function useGetSSOStatusQuery(organizationId: number) {
  return useQuery({
    queryKey: ['sso-status', organizationId],
    queryFn: () => getSSOStatus(organizationId),
    enabled: !!organizationId,
  });
}
